<template>
  <v-card class="d-flex flex-column my-4">
    <div class="pa-3 border-bottom" style="background-color: #f2f2f2;">
      <h3>WaizmannTabelle</h3>
      <h2> PZR Flatrate <sup class="text-pink">Neu</sup></h2>
    </div>
    
    <div class="pa-4" >
      <v-row>
        <v-col cols="6">
          <img
            :src="require('@/assets/bestellung/auftstellerPzr.jpg')"
            class="text-white align-end"
            
        height="160"
      />
      </v-col>
      <v-col cols="6"   class="d-flex flex-column justify-end">
        <div class="mb-4">
        Die WaizmannTabelle für Ihren Prophylaxe-Bereich.
      </div>
        <v-btn color="pink" to="/waizmanntabellen_bestellen" width="100%">kostenlos anfordern</v-btn>
      </v-col>
    </v-row>
    </div>
 
  </v-card>
</template>

<script setup>



</script>

<style scoped>
.border-bottom {
  border-bottom: 1px solid #088a85;
}

.text-primary {
  color: #088a85;
}
</style>
